import React, { useEffect } from "react";
import Header from "@/components/landing/Header";
import NewsletterSignup from "@/components/landing/NewsletterSignup";
import PageFooter from "@/components/landing/PageFooter";

const CONTACT_EMAIL = "enikoszasztoth@gmail.com";
const CONTACT_PHONE_DISPLAY = "+36 20 266 7599";
const CONTACT_PHONE_LINK = "+36202667599"; // E.164 — no spaces, tel: friendly

export default function Contact() {
  // Page-level SEO (per-page title + description, no global changes)
  useEffect(() => {
    const prevTitle = document.title;
    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content") || null;

    document.title = "Kapcsolat | Szász-Tóth Enikő";
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Kapcsolódj Szász-Tóth Enikővel — e-mail, telefon és hírlevél-feliratkozás egy helyen."
      );
    }
    return () => {
      document.title = prevTitle;
      if (metaDesc && prevDesc != null) metaDesc.setAttribute("content", prevDesc);
    };
  }, []);

  return (
    <main
      data-testid="contact-page"
      className="bg-warm text-graphite min-h-screen"
    >
      <Header />
      <div className="pt-20 md:pt-24" />

      {/* HERO */}
      <section
        data-testid="contact-hero"
        className="px-6 md:px-10 pt-4 md:pt-6 pb-5 md:pb-7"
      >
        <div className="max-w-2xl mx-auto text-center">
          <p className="font-body text-[11px] md:text-[12px] tracking-[0.42em] uppercase text-gold mb-4">
            — Kapcsolat
          </p>
          <p className="font-serif-display italic text-graphite text-[18px] md:text-[20px] leading-[1.6] max-w-xl mx-auto">
            Ha szeretnél kapcsolódni, kérdésed van,
            <br className="hidden md:block" />
            vagy érdeklődsz valamelyik folyamat iránt,
            <br className="hidden md:block" />
            keress bizalommal.
          </p>
        </div>
      </section>

      {/* CONTACT DETAILS */}
      <section
        data-testid="contact-details"
        className="px-6 md:px-10 pb-10 md:pb-14"
      >
        <div className="max-w-xl mx-auto">
          <div className="border border-hairline bg-tinted px-6 md:px-8 py-7 md:py-8 text-center">
            {/* Email */}
            <div className="mb-5 md:mb-6">
              <p className="font-body text-[10px] md:text-[10.5px] tracking-[0.35em] uppercase text-gold mb-2">
                — E-mail
              </p>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                data-testid="contact-email-link"
                className="font-serif-display text-graphite text-[18px] sm:text-[20px] md:text-[22px] leading-none tracking-tight hover:text-gold transition-colors duration-300 break-all"
              >
                {CONTACT_EMAIL}
              </a>
            </div>

            <div className="h-px w-12 mx-auto bg-gold opacity-40" aria-hidden="true" />

            {/* Phone */}
            <div className="mt-5 md:mt-6">
              <p className="font-body text-[10px] md:text-[10.5px] tracking-[0.35em] uppercase text-gold mb-2">
                — Telefon
              </p>
              <a
                href={`tel:${CONTACT_PHONE_LINK}`}
                data-testid="contact-phone-link"
                className="font-serif-display text-graphite text-[20px] sm:text-[22px] md:text-[24px] leading-none tracking-tight hover:text-gold transition-colors duration-300"
              >
                {CONTACT_PHONE_DISPLAY}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* NEWSLETTER (reuses the same component + MailerLite backend) */}
      <NewsletterSignup source="contact" compact />

      <PageFooter />
    </main>
  );
}
